import { Close } from '@mui/icons-material'
import { Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material'
import { useClassificationPageDetails } from '@src/api/report-api'
import PageLoader from '@src/components/Loader/PageLoader'
import PagesView from '@src/containers/ViewDocument/PagesView'
import { DocsAutomation, EProcessingStatus } from '@src/types/automationDocument'
import { useEffect, useMemo } from 'react'

interface DocumentPagesDialogProps {
  open: boolean
  onClose: () => void
  pageIds: string[]
  title: string
}

const DocumentPagesDialog = ({ open, onClose, pageIds, title }: DocumentPagesDialogProps) => {
  const { mutate, data, isPending } = useClassificationPageDetails()

  useEffect(() => {
    if (open && pageIds.length > 0) {
      mutate(pageIds)
    }
  }, [open, pageIds, mutate])

  // Create a minimal document object for PagesView
  const dummyDocument: DocsAutomation = useMemo(
    () => ({
      id: '',
      containsContract: false,
      email: null,
      extractedData: null,
      extractedReferenceNumbers: [],
      systemMatchingResult: null,
      processingStatus: EProcessingStatus.Processed,
      processingNotes: [],
      warnings: [],
      linkedCreditApp: {
        id: 0,
        dccNumber: 0,
        cvtNumber: 0,
        clientName: '',
        productLine: 0,
        formattedProductLine: '',
        office: '',
        statusId: 0,
        status: '',
        statusEn: '',
        link: '',
        creationDT: '',
        error: '',
        applicantName: '',
        coApplicantName: '',
        hasCoApplicant: false,
      },
      originSystem: '',
      sentDocumentTypeIds: [],
      versionTag: '',
      createdOn: '',
      createdByUserFullname: '',
      createdByUserId: '',
      updatedOn: '',
      updatedByUserFullname: '',
      updatedByUserId: '',
      tags: [],
    }),
    [],
  )

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">{title}</Typography>
          <IconButton onClick={onClose} size="small">
            <Close />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ p: 3, height: '85vh' }}>
        {isPending ? (
          <PageLoader />
        ) : (
          data &&
          data.length > 0 && (
            <PagesView
              pages={data}
              document={dummyDocument}
              onDocTypeChange={() => {}}
              viewOnly
              canGoNext={false}
              onOpenLinkDialog={() => {}}
            />
          )
        )}
      </DialogContent>
    </Dialog>
  )
}

export default DocumentPagesDialog
